import React from 'react'

import {
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

type Props = {
  isOpen: boolean
  onClose: () => void
  onFinish: () => void
}

export const LeaveLobbyModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onFinish,
}) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent>
      <ModalCloseButton />
      <ModalHeader>面談から退出しますか？</ModalHeader>
      <ModalFooter>
        <Button colorScheme="green" onClick={onClose}>
          面談を継続する
        </Button>
        <Button
          colorScheme="red"
          onClick={() => {
            onFinish()
            onClose()
          }}
        >
          退出する
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
)
